import { type Message, useChat } from '@ai-sdk/react';

import type { AIInputStateControl } from '@modules/ai-conversation/components/AIInput';

import { getContextFilesMessages } from 'src/sections/@dashboard/ai/shared/utils';
import { Session } from 'src/state';
import { axios } from 'src/utils/axios';

export const useSendAIPromptMessage = (control: AIInputStateControl) => {
  const { messages, setMessages, append, status, stop } = useChat({
    api: `${axios.defaults.baseURL}/ai/chat/conversation/message`,
    headers: {
      authorization: Session.getToken() || '',
      'Content-Type': 'application/json',
    },
    streamProtocol: 'data',
    sendExtraMessageFields: true,
    onFinish: () => setIsLoading(false),
    onError: (error) => {
      setError(error.message);
      setIsLoading(false);
    },
  });

  const {
    selectedContext,
    contextFiles,
    think,
    doSearch: search,
    generateImage,
    setIsLoading,
    setError,
  } = control((s) => ({
    selectedContext: s.selectedContext,
    contextFiles: s.contextFiles,
    think: s.think,
    doSearch: s.doSearch,
    generateImage: s.generateImage,
    setIsLoading: s.setIsLoading,
    setError: s.setError,
  }));

  const appendMessage = (message: Message) => {
    setMessages((state) => [...state, message]);
  };

  const sendMessage = async (message: string) => {
    await append(
      {
        role: 'user',
        content: message,
      },
      {
        body: {
          content: message,
          messagesHistory: messages,
          contextMessage: selectedContext === '/' ? undefined : selectedContext,
          think,
          search,
          generateImage,
          contextFiles: getContextFilesMessages(contextFiles),
        },
      },
    );
  };

  return {
    messages,
    appendMessage,
    sendMessage,
    status,
    stop,
  };
};
